/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import appConfig from 'app-config';
import { appendMetadataWithIndex } from 'ml-portals-util-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import MLPAUMBTermMultipleOptComponent from '../MLPAUMBTermMultipleOptComponent/MLPAUMBTermMultipleOptComponent';
import '@xengage/gw-platform-translations';
import styles from './MLPAUMBCovTermComponent.module.scss';
import metadata from './MLPAUMBCovTermComponent.metadata.json5';
import { Submission } from 'gw-capability-quoteandbind';

function MLPAUMBCovTermComponent(props) {
    const {
        coverage,
        index,
        editMode,
        getChosenTermValue,
        hasSingleOption,
        getSingleOption,
        isYesNoOption,
        hasMultipleOptions,
        getOptionName,
        hasNoOptions
    } = props;

    const isQnB = appConfig.portalCode === 'QB';
    const PASumbission = new Submission()

    const resolvers = {
        resolveComponentMap: {
            MLPAUMBTermMultipleOptComponent: MLPAUMBTermMultipleOptComponent
        },
        resolveClassNameMap: styles
    };

    useEffect(() => {
        if (coverage.name === 'First Party Benefits') {
            const combinationPackageValue = coverage.terms.filter((cov) => cov.name === 'Combination Package' && cov.value === undefined);
            if (_.isEmpty(combinationPackageValue) && coverage.terms.length === 9) {
                coverage.terms.splice(1, 4);
            } else if (!_.isEmpty(combinationPackageValue) && coverage.terms.length === 9) {
                coverage.terms.splice(5, 4);
            }
        }
    }, [coverage.terms, coverage.name]);

    const generateTermOverrides = useCallback(() => {
        const termOverrides = coverage.terms.map((term, termIndex) => {
            return {
                [`termValue${index}${termIndex}`]: {
                    visible: !editMode || !term.isEditable_ML,
                    content: getChosenTermValue(term)
                },
                [`termForm${index}${termIndex}`]: {
                    visible: editMode && term.isEditable_ML
                },
                [`singleOptionTerm${index}${termIndex}`]: {
                    visible: term.isVisible_ML && hasSingleOption(term),
                    content: getSingleOption(term)
                },
                [`multipleOptionTerm${index}${termIndex}`]: {
                    visible: term.isVisible_ML && !hasSingleOption(term),
                    term: term,
                    getChosenTermValue: getChosenTermValue,
                    hasSingleOption: hasSingleOption,
                    getSingleOption: getSingleOption,
                    isYesNoOption: isYesNoOption,
                    hasMultipleOptions: hasMultipleOptions,
                    getOptionName: getOptionName,
                    hasNoOptions: hasNoOptions,
                    covIndex: index,
                    termIndex: termIndex,
                    className: (PASumbission.isPersonalAuto && isQnB) ? styles.radioBtnFlex : styles.verticalSpacing20
                }
            };
        });

        return Object.assign({}, ...termOverrides);
    }, [coverage.terms, index, editMode, getChosenTermValue, hasSingleOption, getSingleOption, isYesNoOption, hasMultipleOptions, getOptionName, hasNoOptions]);

    const overrides = {
        [`covTermLoop${index}`]: {
            data: coverage.terms
        },
        ...generateTermOverrides()
    };

    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, index);

    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers} />;
}

MLPAUMBCovTermComponent.propTypes = {
    coverage: PropTypes.shape({}),
    index: PropTypes.number,
    editMode: PropTypes.bool,
    getChosenTermValue: PropTypes.func,
    hasSingleOption: PropTypes.func,
    getSingleOption: PropTypes.func,
    isYesNoOption: PropTypes.func,
    hasMultipleOptions: PropTypes.func,
    getOptionName: PropTypes.func,
    hasNoOptions: PropTypes.func,
};

export default MLPAUMBCovTermComponent;
